const adminSurveyRouter = [
  {
    path: '/admin/survey',
    name: 'AdminSurveyIndex',
    component: () => import('@/views/admin/survey/index')
  },
  {
    path: '/admin/survey/create',
    name: 'AdminSurveyCreate',
    component: () => import('@/views/admin/survey/create')
  },
  {
    path: '/admin/survey/edit',
    name: 'AdminSurveyEdit',
    component: () => import('@/views/admin/survey/edit')
  },
  {
    path: '/admin/survey/link',
    name: 'AdminSurveyLink',
    component: () => import('@/views/admin/survey/link')
  },
  {
    path: '/admin/survey/result',
    name: 'AdminSurveyResult',
    component: () => import('@/views/admin/survey/result')
  }
]

export default adminSurveyRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/survey.js